import api from '@/helpers/api'

export default {
    namespaced: true,
    state: {
        status: '',
        featureFlagAuditLogs: [],
        meta: {
            page: 1,
            limit: 10,
            total: 1
        },
        filter: {},
        search: {}
    },
    mutations: {
        request(state) {
            state.status = 'loading'
        },
        read(state, { featureFlagAuditLogs }) {
            state.featureFlagAuditLogs = [...featureFlagAuditLogs]
        },
        error(state) {
            state.status = 'error'
        },
        success(state) {
            state.status = 'success'
        },
        switch_page(state, { meta }) {
            state.meta = { ...meta }
        },
        add_filter(state, { filter }) {
            state.filter = filter
        },
        set_search(state, { search }) {
            state.search = { ...search }
        },
        clear_search(state) {
            state.search = {}
        },
        reset_meta(state) {
            state.meta = {
                limit: 10,
                page: 1,
                total: 1
            }
        }
    },
    actions: {
        read({ commit, state }, corporateId = null) {
            commit('request')
            const { meta } = state
            const { filter } = state
            const { search } = state

            const API_READ = `/api/feature-flags/audit-logs/${corporateId}`

            return new Promise((resolve, reject) => {
                api.request('get', API_READ, { meta, filter, search })
                    .then((response) => {
                        const featureFlagAuditLogs = response.data.data

                        commit('read', { featureFlagAuditLogs })
                        commit('success')

                        commit('switch_page', { meta: { ...response.data.meta } })
                        return resolve(featureFlagAuditLogs)
                    }).catch((err) => {
                        commit('error')
                        return reject(err)
                    }).finally(() => {
                    })
            })
        }
    },
    getters: {
        featureFlagAuditLogs: () => state => state.featureFlagAuditLogs
    }
}
